<template>
  <div class="login">
    <div class="login-box">
      <div class="login-left"></div>
      <div class="login-right">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
        >
         <div class="login-head">
             <img class="login-logo" v-if="logo" :src="logo" />
             <h3 class="title">{{ title }}</h3>
         </div>
          
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              type="text"
              auto-complete="off"
              placeholder="账号"
            >
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              auto-complete="off"
              placeholder="密码"
              @keyup.enter.native="handleLogin"
            >
             <i slot="prefix" class="el-input__icon el-icon-key"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" v-if="captchaEnabled">
            <el-input
              v-model="loginForm.code"
              auto-complete="off"
              placeholder="验证码"
              @keyup.enter.native="handleLogin"
            >
              <svg-icon
                slot="prefix"
                icon-class="validCode"
                class="el-input__icon input-icon"
              />
            </el-input>
            <div class="login-code">
              <img :src="codeUrl" @click="getCode" class="login-code-img" />
            </div>
          </el-form-item>
          <el-checkbox
            v-model="loginForm.rememberMe"
            style="margin:0px 0px 25px 0px;text-align:left"
            >记住密码</el-checkbox
          >
          <el-form-item>
            <el-button
              :loading="loading"
              size="medium"
              type="primary"
              @click.native.prevent="handleLogin"
                style="width:100%"
            >
              <span v-if="!loading">登 录</span>
              <span v-else>登 录 中...</span>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import idaas from "@/apis/idaas";
import Cookies from "js-cookie";
import logoImg from "@/static/icon_login.png";

export default {
  name: "Login",
  data() {
    return {
      title: "",
      logo: "",
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        state: "",
        code: "",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "用户名不能为空" }
        ],
        password: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ]
        // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      loading: false,
      redirect: undefined,
      captchaEnabled:false,
      checkAll: false,
      checkedCities: ['上海', '北京'],
      cities: ['上海', '北京', '广州', '深圳'],
      isIndeterminate: true
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  async created() {
    // this.getCode();
    console.log("router", this.$route)
    this.loginForm.state = this.$route.query.state;
    this.getCookie();
    idaas.app(this.$route.query.state).then((res)=>{
      this.title = res.data.name
      document.title=res.data.name
      if (res.data.icon){
        this.logo = this.$baseUrl+"/idaas/logo/"+res.data.icon
      }else{
        this.logo =  logoImg
      }
    }).catch((res)=>{
      console.log(res)
      this.title = "统一认证"
      this.logo =  logoImg
    })
    
  },
  methods: {
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.enabled;
        if(res.data.enabled){
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe');
      const connId = Cookies.get('connId');
      console.log(connId,this.loginForm.connId)
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
        state: this.loginForm.state,
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", this.loginForm.password, { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
            Cookies.set('connId', this.loginForm.connId, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
            Cookies.remove('connId');
          }
          console.log(this.loginForm)
          idaas.login(this.loginForm,this.loginForm.state).then((res) => {
            window.open(res.data.url,"_self")
            //this.$router.push({ path: res.data.url || "/" })
          }).catch((res) => {
            console.log(res)
            if (res.data.code==10013){
              this.$msgbox.confirm('登录页面已过期，您可以继续留在该页面，或者重新进入', '系统提示', {
                  confirmButtonText: '重新进入',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              ).then(() => {
                window.history.back(-1) 
              }).catch(() => {});
            }
            this.loading = false;
            // this.getCode();
          });
        }
      });
    }
  }
};
</script>


<style scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #d2e9ff;
}
.login-box {
  border-radius: 6px;
  background: #ffffff;
  width: 800px;
  height: 500px;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}
.login-left {
  float: left;
  border-radius: 6px 0 0 6px;
  width: 40%;
  height: 100%;
  background-image: url("../../static/kj.jpg");
  background-size: cover;
  background-blend-mode: multiply;
  background-color: #33ffff;
}
.login-right {
  float: left;
  width: 60%;
}
.login-form{
  width: 80%;
  padding: 65px 25px 5px 25px;
}
.login-head{
  text-align: center;
}
.login-logo{
    width: 60px
}
</style>
